module.exports = __webpack_public_path__ + "static/img/fish41.727fb9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish41.png
// module id = 1lS6
// module chunks = 0